
import vue from 'vue';

// Services
import DialogService from '~/services/DialogService';

// Components
import Button from '~/components/builders/Base/Button.vue';
import UserConsentContext from '~/services/UserConsentContext';

// Types
export default vue.extend({
    name: 'BottomNotice',
    components: { Button },
    methods: {
        openConsentModal() {
            DialogService.openCookieConsentDialog();
        },
        acceptAll() {
            UserConsentContext.acceptAll();
        },
    },
});
